import { useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API";
import { useSignups } from "Signups/state";
import { AnimatePresence, motion } from "framer-motion";

import FnrIcon from "UI/FnrIcon";
import FnrLoadingBricks from "UI/FnrLoadingBricks2";
import { FnrToggleChild } from "UI/FnrToggle2";
import { colors } from "UI/colors";

export default function TemplateBox({
  ID,
  simpleLabel,
  label,
  icon,
  text,
  onClick,
  selected,
  index,
  hasFundItText,
  needsFundItText,
  checkAnimationComplete,
  hasSignupPayments,
  hasFundIt,
  isSuperAdmin,
  isAdminOfAnyGroup,
  duplicate = false,
}) {
  const [loading, setLoading] = useState(false);

  const [, dispatch] = useSignups();

  const duplicateSignup = (signupListID) => {
    if (loading) return;

    setLoading(true);

    API.duplicate(signupListID)
      .then((res) => {
        if (res.allSignupLists) {
          dispatch({
            type: "Update All Signup Lists",
            allSignupLists: res.allSignupLists,
          });
        }
        //i don't like this but it was redirecting away from the new signup for some reason
        window.location = `/signups/${res.signupListID}/items`;
      })
      .catch(() => {
        alert("Something went wrong");
        setLoading(false);
      });
  };

  const clicked = duplicate ? duplicateSignup : onClick;

  return (
    <Wrapper
      onClick={() => clicked(ID)}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0, transition: { delay: index * 0.05 } }}
      data-cy="TemplateBox_Wrapper"
    >
      <FnrToggleChild forceHover={loading}>
        <Inside>
          <Icon>
            <FnrIcon fad icon={icon} />
          </Icon>
          <Title>
            {simpleLabel || label}
            <Descrip
              text={text}
              hasFundItText={hasFundItText}
              needsFundItText={needsFundItText}
              hasFundIt={hasFundIt}
              hasSignupPayments={hasSignupPayments}
              isSuperAdmin={isSuperAdmin}
              isAdminOfAnyGroup={isAdminOfAnyGroup}
            />
          </Title>
        </Inside>
      </FnrToggleChild>
      <LoadingHolder>
        <FnrLoadingBricks loading={loading} size={24} color="#278dc1" />
      </LoadingHolder>
      <AnimatePresence>
        {!duplicate && selected && (
          <Checked
            initial={{ opacity: 0, scale: 0.2 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{
              opacity: 0,
              transition: { duration: 0.1 },
            }}
            onAnimationComplete={checkAnimationComplete}
          >
            <FnrIcon fas fa-check-circle />
          </Checked>
        )}
      </AnimatePresence>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  cursor: pointer;
  position: relative;
  width: 100%;
`;

const Inside = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 12px;
  transition: color 0.2s;
  &:hover {
    color: #278dc1;
  }
`;

const Icon = styled.div`
  font-size: 28px;
  width: 40px;
  text-align: center;
  margin-right: 18px;
  flex-shrink: 0;
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  flex-grow: 1;
  margin-right: 42px;
`;
const DescripWrapper = styled.div`
  color: #828c8d;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 2px;
`;
const Checked = styled(motion.div)`
  font-size: 24px;
  width: 32px;
  text-align: center;
  margin-left: 12px;
  color: ${colors.fnBlue};
  position: absolute;
  right: 12px;
  z-index: 5000;
  top: 50%;
  height: 24px;
  line-height: 24px;
  margin-top: -12px;
`;

const LoadingHolder = styled.div`
  width: 32px;
  margin-left: 12px;
  position: absolute;
  right: 12px;
  z-index: 5000;
  top: 50%;
  height: 24px;
`;

const Descrip = ({
  text,
  hasFundItText,
  needsFundItText,
  hasFundIt,
  hasSignupPayments,
  isSuperAdmin,
  isAdminOfAnyGroup,
}) => {
  if (hasFundIt && hasFundItText)
    return (
      <DescripWrapper>
        {text} {isAdminOfAnyGroup ? hasFundItText : ""}
      </DescripWrapper>
    );

  if (
    !hasSignupPayments ||
    !isSuperAdmin ||
    (!needsFundItText && !hasFundItText)
  )
    return <DescripWrapper>{text}</DescripWrapper>;

  const parts = needsFundItText.split("Fund It");

  return (
    <DescripWrapper>
      {text}{" "}
      {parts.map((text, index, allParts) => {
        return (
          <span key={index}>
            {text}
            {index < allParts.length - 1 && (
              <LinkSpan onClick={() => window.fnReactBus.goToUrl("/fundit")}>
                Fund It
              </LinkSpan>
            )}
          </span>
        );
      })}
    </DescripWrapper>
  );
};

const LinkSpan = styled.span`
  color: #278dc1;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
